import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { requestGet } from '../../api/request';
import { NODE_SHOW } from '../../api/url';
import * as actions from '../../redux/actions';

const EventByNodeId = () => {
  const { nodeId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const listLanguage = useSelector(
    (state) => state.languageReducer.list_language,
  );

  const setNewLanguage = (nodeLanguageId) => {
    for (let i = 0; i < listLanguage.length; i += 1) {
      if (listLanguage[i].id === nodeLanguageId) {
        dispatch(actions.setCurrentLanguage(listLanguage[i]));
      }
    }
  };

  const letRedirect = (recievedData) => {
    if (recievedData.news_type_relation[0] === undefined) {
      navigate('/');
    }
    if (recievedData.news_type_relation[0].news_type.type === 'news') {
      if (recievedData.news_type_relation[0].news_type.name === 'in_trips') {
        navigate(
          `/event/domestic_trips/${recievedData.news_type_relation[0].news_id}`,
        );
      }
      if (recievedData.news_type_relation[0].news_type.name === 'out_trips') {
        navigate(
          `/event/foreign_trips/${recievedData.news_type_relation[0].news_id}`,
        );
      }
      if (
        recievedData.news_type_relation[0].news_type.name !== 'in_trips'
        && recievedData.news_type_relation[0].news_type.name !== 'out_trips'
      ) {
        navigate(
          `/event/'${recievedData.news_type_relation[0].news_type.name}/${recievedData.news_type_relation[0].news_id}`,
        );
      }
    }
    if (recievedData.news_type_relation[0].news_type.type === 'documents') {
      navigate(
        `/event/${recievedData.news_type_relation[0].news_type.type}/${recievedData.news_type_relation[0].news_type.name}/${recievedData.news_type_relation[0].news_id}`,
      );
    }
    if (
      recievedData.news_type_relation[0].news_type.type === 'internal_politics'
    ) {
      navigate(
        `/event_by_theme/internal_politics/${recievedData.news_type_relation[0].news_type.name}/${recievedData.news_type_relation[0].news_id}`,
      );
    }
    if (
      recievedData.news_type_relation[0].news_type.type
      === 'international_structures'
    ) {
      navigate(
        `/event_by_theme/international_structures/${recievedData.news_type_relation[0].news_type.name}/${recievedData.news_type_relation[0].news_id}`,
      );
    }
    if (
      recievedData.news_type_relation[0].news_type.type
      === 'bilateral_relations'
    ) {
      navigate(
        `/event_by_theme/bilateral_relations/${recievedData.news_type_relation[0].news_type.name}/${recievedData.news_type_relation[0].news_id}`,
      );
    }
  };

  const getData = async () => {
    const response = await requestGet(NODE_SHOW, {
      'remote_nid': nodeId,
    });

    if (response.success) {
      setNewLanguage(response.data.language_id);
      letRedirect(response.data);
    }
  };

  useEffect(() => {
    if (dictionary) {
      getData();
    }
  }, [nodeId]);
};

export default EventByNodeId;
